import * as React from 'react';
import { Box, Container, Typography, Tooltip } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Busqueda from './Busqueda';

export default function Proyectos() {
  const [cambiador, setCambiador] = React.useState(0);

  const actualizarCliente = () => {
    setCambiador(prev => prev + 1);
  };

  const clienteNombre = localStorage.getItem('Cliente') || '';

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f5f7fa', display: 'flex', flexDirection: 'column' }}>

      {/* ── HEADER ENTERPRISE ── */}
      <Box
        component="header"
        sx={{
          backgroundColor: '#ffffff',
          boxShadow: '0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.06)',
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          borderBottom: '3px solid #c82339',
        }}
      >
        <Container maxWidth="xl">
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              py: 1.5,
            }}
          >
            {/* Logo + Nombre empresa */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box sx={{ borderLeft: '1px solid #e0e0e0', pl: 2 }}>
                <Typography
                  sx={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 800,
                    fontSize: '13px',
                    color: '#000000',
                    letterSpacing: '0.08em',
                    textTransform: 'uppercase',
                  }}
                >
                  Portal de Proyectos
                </Typography>
              </Box>
            </Box>

            {/* Info cliente (aparece después de buscar) */}
            {clienteNombre && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  backgroundColor: '#fff5f6',
                  border: '1px solid #ffd0d5',
                  borderRadius: '8px',
                  px: 2,
                  py: 0.75,
                }}
              >
                <Box
                  sx={{
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    backgroundColor: '#c82339',
                  }}
                />
                <Typography
                  sx={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 500,
                    fontSize: '13px',
                    color: '#1a2332',
                  }}
                >
                  Cliente:&nbsp;
                  <Box component="span" sx={{ fontWeight: 700, color: '#c82339' }}>
                    {clienteNombre}
                  </Box>
                </Typography>
              </Box>
            )}
          </Box>
        </Container>
      </Box>

      {/* ── CONTENIDO PRINCIPAL ── */}
      <Box sx={{ flex: 1 }}>
        <Busqueda Datos={actualizarCliente} />
      </Box>

      {/* ── BOTÓN FLOTANTE WHATSAPP ── */}
      <Tooltip title="Contactar Servicio Técnico por WhatsApp" placement="left" arrow>
        <Box
          component="a"
          href="https://wa.me/573183585528?text=¡Hola! Estaba en tu sitio web y necesito consultar al Técnico en Línea"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            position: 'fixed',
            bottom: 28,
            right: 28,
            zIndex: 1300,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            backgroundColor: '#25D366',
            color: '#ffffff',
            textDecoration: 'none',
            borderRadius: '50px',
            px: 2.5,
            py: 1.25,
            boxShadow: '0 4px 16px rgba(37,211,102,0.45)',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 600,
            fontSize: '13px',
            letterSpacing: '0.02em',
            transition: 'all 0.2s ease',
            '&:hover': {
              backgroundColor: '#20bc5a',
              transform: 'translateY(-2px)',
              boxShadow: '0 6px 20px rgba(37,211,102,0.55)',
            },
          }}
        >
          <WhatsAppIcon sx={{ fontSize: 20 }} />
          Servicio Técnico
        </Box>
      </Tooltip>

      {/* ── FOOTER ── */}
      <Box
        component="footer"
        sx={{
          backgroundColor: '#ffffff',
          borderTop: '1px solid #e8ecf0',
          py: 2,
          mt: 'auto',
        }}
      >
        <Container maxWidth="xl">
          <Typography
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontSize: '12px',
              color: '#9aa5b4',
              textAlign: 'center',
            }}
          >
            © {new Date().getFullYear()} TALSA · Todos los derechos reservados
          </Typography>
        </Container>
      </Box>
    </Box>
  );
}
